var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('HeaderContact',{attrs:{"phone":_vm.phone}}),_c('HeaderNav',{attrs:{"logoLarge":_vm.logoLarge,"logoSmall":_vm.logoSmall}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }